import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e26ef04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "images-uploader" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "images-uploader__image-actions" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" Перетащите сюда файл или "),
  /*#__PURE__*/_createElementVNode("em", null, "нажмите для загрузки")
], -1))
const _hoisted_8 = ["src"]

import { onUnmounted, ref } from 'vue'
import {
  Delete,
  RefreshRight,
  UploadFilled,
  ZoomIn,
} from '@element-plus/icons-vue'
import {
  UploadFileRotate,
  useReportCreation,
} from '@/widgets/WReportCreation/composables/useReportCreation'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { images } = useReportCreation()

const dialogImageUrl = ref('')
const dialogVisible = ref(false)

const handleUploadImage = (file: UploadFileRotate): void => {
  file.degree = 0
  images.value.push(file)
}

const handlePreviewImage = (uploadFile: UploadFileRotate): void => {
  dialogImageUrl.value = uploadFile.url!
  dialogVisible.value = true
}

const handleRemoveImage = (file: UploadFileRotate): void => {
  images.value = images.value.filter((image) => {
    return image.uid !== file.uid
  })
}

const handleRotateImage = (file: UploadFileRotate): void => {
  file.degree += 90
}

onUnmounted(() => {
  images.value = []
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_upload, {
      class: "images-uploader__content",
      "file-list": _unref(images),
      "onUpdate:file-list": _cache[0] || (_cache[0] = ($event: any) => (_isRef(images) ? (images).value = $event : null)),
      "list-type": "picture",
      accept: "image/*",
      drag: "",
      multiple: "",
      "auto-upload": false,
      "on-change": handleUploadImage
    }, {
      file: _withCtx(({ file }) => [
        _createElementVNode("img", {
          class: "images-uploader__image",
          style: _normalizeStyle({ transform: `rotate(${file.degree}deg)` }),
          src: file.url
        }, null, 12, _hoisted_2),
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("span", {
            class: "images-uploader__image--preview",
            onClick: ($event: any) => (handlePreviewImage(file))
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ZoomIn))
              ]),
              _: 1
            })
          ], 8, _hoisted_4),
          _createElementVNode("span", {
            class: "images-uploader__image--delete",
            onClick: ($event: any) => (handleRotateImage(file))
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(RefreshRight))
              ]),
              _: 1
            })
          ], 8, _hoisted_5),
          _createElementVNode("span", {
            class: "images-uploader__image--delete",
            onClick: ($event: any) => (handleRemoveImage(file))
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Delete))
              ]),
              _: 1
            })
          ], 8, _hoisted_6)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
          default: _withCtx(() => [
            _createVNode(_unref(UploadFilled))
          ]),
          _: 1
        }),
        _hoisted_7
      ]),
      _: 1
    }, 8, ["file-list"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          class: "images-uploader__dialog",
          src: dialogImageUrl.value,
          alt: "Preview Image"
        }, null, 8, _hoisted_8)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})